import React from "react";

import RegistrationForm from "./Calc/Calculator";
import UseR from "./Use-Reducer/Use-R";
import UserRComplex from "./Use-Reducer/Use-R-complex";
import UseEffectExplore from "./Use-Effect/Use-Effect";
import UseMemo from "./UseMemo/UseMemo";
import UseRef from "./UseRef/UseRef";
import UseContextDemo from "./UseContext/UseContextDemo";
import ThemeSetter from "./UseContext/ThemeContextCode";
import UseCallBack from "./UseCallBack/UseCallBack";

export default function Hooks() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        width: "70%",
        margin: "auto",
      }}
    >
      <div className="container">
        <div className="row">
          <h2>useState:</h2>
          <RegistrationForm />
        </div>
      </div>
      <hr />
      <div className="container">
        <div className="row">
          <h2>useReducer - simple usage:</h2>
          <UseR />
        </div>
      </div>
      <hr />
      <div className="container">
        <div className="row">
          <h2>useReducer - complex usage:</h2>
          <UserRComplex />
        </div>
      </div>
      <hr />
      <div className="container">
        <div className="row">
          <h2>useEffect:</h2>
          <UseEffectExplore />
        </div>
      </div>
      <hr />
      <div className="container">
        <div className="row">
          <h2>useMemo:</h2>
          <UseMemo />
        </div>
      </div>
      <hr />
      <div className="container">
        <div className="row" style={{ display: "grid" }}>
          <h2 style={{ textAlign: "left" }}>useRef:</h2>
          <UseRef />
        </div>
      </div>
      <hr />
      <div className="container">
        <div className="row" style={{ display: "grid" }}>
          <h2 style={{ textAlign: "left" }}>useContext:</h2>
        </div>
        <ThemeSetter />
      </div>
      <hr />
      <div className="container">
        <div className="row" style={{ display: "grid" }}>
          <h2 style={{ textAlign: "left" }}>useCallback:</h2>
        </div>
        <UseCallBack />
      </div>
      <hr />
    </div>
  );
}
